import { makeObservable, observable, runInAction } from 'mobx';

import { Ticket } from '~hooks/useTickets/models';
import { RootStore } from '~store/RootStore';

class TicketsStore {
  tickets: Ticket[] = [];
  analyzingTickets: Map<string, boolean> = new Map();

  constructor(private readonly rootStore: RootStore) {
    makeObservable(this, {
      tickets: observable,
      analyzingTickets: observable,
    });
    this.rootStore = rootStore;
  }

  setTickets(tickets: Ticket[]) {
    runInAction(() => {
      this.tickets = [...tickets];
    });
  }

  deleteTicket(id: string) {
    runInAction(() => {
      this.tickets = this.tickets.filter((t) => t.id !== id);
    });
  }

  updateTicket(order: Ticket) {
    this.tickets = this.tickets.map((t) => (t.id === order.id ? order : t));
  }

  ticketAnalysisStart(ticketId: string) {
    runInAction(() => {
      this.analyzingTickets.set(ticketId, true);
    });
  }

  ticketAnalysisEnd(ticketId: string) {
    runInAction(() => {
      this.analyzingTickets.delete(ticketId);
    });
  }
}

export default TicketsStore;
